import {Navigate, Outlet} from 'react-router-dom'
import {useUserStateProvider} from '../utils/contextProvider/UserStateProvider'
import {useAuth} from '../modules/auth'
import LoadingBar from '../utils/components/Loading/LoadingBar'

interface ProtectedRouteProps {
  menu: string
  submenu?: string
}
const ProtectedRoute = ({menu, submenu}: ProtectedRouteProps) => {
  const {currentUser} = useAuth()

  const {roleDetailMenus, sidebarFooterMenus, loadingMenu, menuLoadedForAuthorId} =
    useUserStateProvider()

  const menus = [...roleDetailMenus, ...sidebarFooterMenus]

  const isMenuReady = currentUser?.author_id === menuLoadedForAuthorId

  const targetMenu = menus.find((m) => m.menu_name === menu)

  if (!isMenuReady) {
    return <LoadingBar />
  }

  if (currentUser?.author_id === 0) {
    return <Outlet />
  }

  if (!targetMenu) {
    return <Navigate to='/forbidden' replace />
  }

  if (submenu) {
    const targetSubmenu = targetMenu.submenus?.find(
      (s) => s.submenu_name.toLowerCase() === submenu.toLowerCase()
    )

    if (targetSubmenu?.view_level !== 'Y') {
      return <Navigate to='/forbidden' replace />
    }
  } else {
    if (targetMenu.view_level !== 'Y') {
      return <Navigate to='/forbidden' replace />
    }
  }

  return <Outlet />
}

export default ProtectedRoute
